
import React from 'react';
import { Plus, Trash2, BookOpen } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const PlanListInput = ({ items, setItems, subjects }) => {

  const handleAddItem = () => {
    setItems([
      ...items,
      { id: Date.now().toString(), subject: 'その他', content: '', isCompleted: false }
    ]);
  };

  const handleRemoveItem = (id) => {
    setItems(items.filter(item => item.id !== id));
  };

  const handleChange = (id, field, value) => {
    setItems(items.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    ));
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-bold text-gray-700 dark:text-gray-300">
        今日のクエスト (ToDoリスト)
      </label>
      
      <div className="space-y-2">
        <AnimatePresence initial={false}>
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="flex gap-2 items-center"
            >
              {/* 教科選択 */}
              <div className="relative w-1/3 min-w-[100px]">
                <select
                  value={item.subject}
                  onChange={(e) => handleChange(item.id, 'subject', e.target.value)}
                  className="w-full pl-2 pr-6 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-orange-400 focus:outline-none appearance-none"
                >
                  {subjects.map(s => <option key={s} value={s}>{s}</option>)}
                  <option value="その他">その他</option>
                </select>
                <BookOpen size={14} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
              </div>

              {/* 内容入力 */}
              <input
                type="text"
                value={item.content}
                onChange={(e) => handleChange(item.id, 'content', e.target.value)}
                placeholder="例: ワーク P10-12"
                className="flex-1 py-2 px-3 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-orange-400 focus:outline-none"
              />

              {/* 削除ボタン */}
              {items.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveItem(item.id)}
                  className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-full transition-colors"
                >
                  <Trash2 size={16} />
                </button>
              )}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <button
        type="button"
        onClick={handleAddItem}
        className="w-full py-2 flex items-center justify-center gap-2 text-sm font-medium text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 hover:bg-orange-100 dark:hover:bg-orange-900/40 rounded-lg border border-orange-200 dark:border-orange-800 transition-colors"
      >
        <Plus size={16} />
        リストを追加
      </button>
    </div>
  );
};

export default PlanListInput;
